import styled from 'styled-components';

export const MileageStyles = styled.div`
  width: 140px;
  min-width: 140px;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 5px;
  font-size: ${({ theme }) => theme.fontSize.nm};
`;
